<div class="fancy-container">

  <!-- Animated Ocean Waves -->
  <div class="ocean">
    <div class="wave"></div>
    <div class="wave wave2"></div>
  </div>

  <!-- Ship Animation -->
  <div class="ship-wrapper">
    <div class="ship">
      🚢
    </div>
  </div>

  <div class="fancy-card">

    <div class="icon-wrapper">
      <div class="glow-ring"></div>
      <mat-icon>engineering</mat-icon>
    </div>

    <h2 class="heading">Under Development</h2>

    <h3 class="module-name">{{ moduleName }}</h3>

    <p class="description">
      This technical performance module is currently under development
      by the IT team. Advanced vessel analytics, engine graphs, and
      performance insights will be available in an upcoming release.
    </p>

    <!-- Animated Data Line -->
    <div class="data-line"></div>

    <div class="badge">
      ⚙ Shipping Analytics Engine – In Progress
    </div>

  </div>

</div>